import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FieldErrorsComponent } from './field-errors.component';
import { ShowAuthedDirective } from './show-authed.directive';
import { PlacesAutocompleteDirective } from './alarm-zone/places-autocomplete.directive';
import { GeocodingService } from './alarm-zone/geocoding.service';
import { EnableControlDirective } from './directives/enable-control.directive';
import { PopUpComponent } from './components/pop-up/pop-up.component';

import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { ChangeAvatarComponent } from './components/change-avatar/change-avatar.component';
import { SearchComponent } from './components/search/search.component';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { NumberCounterComponent } from './components/number-counter/number-counter.component';
import { SliderComponent } from './components/slider/slider.component';
import { HoursBarComponent } from './components/hours-bar/hours-bar.component';
import { AlarmZoneComponent } from './components/alarm-zone/alarm-zone.component';
import { RouteRefreshComponent } from './route-refresh.component';
import { AgmCoreModule } from '@agm/core';
import { CurrentDateComponent } from './components/current-date/current-date.component';
import { ValidateErrorsComponent } from './components/validate-errors/validate-errors.component';
import { SignalStrengthComponent } from './components/signal-strength/signal-strength.component';
import { FilterButtonComponent } from './components/filter-button/filter-button.component';
import { RangeDatePickerComponent } from './components/range-date-picker/range-date-picker.component';
import { SosAlertComponent } from './components/sos-alert/sos-alert.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { CheckStatusComponent } from './components/check-status/check-status.component';
import { ShowAvatarComponent } from './components/show-avatar/show-avatar.component';
import { ShowAlertInfoComponent } from './components/show-alert-info/show-alert-info.component';
import { ShowAlertInfoIntegrateComponent } from './components/show-alert-info-integrate/show-alert-info-integrate.component';
import { LoadingModule } from 'ngx-loading';
import { ShowMapInfoComponent } from './components/show-map-info/show-map-info.component';
import { DiagramComponent } from './components/diagram/diagram.component';
import { DiagramRoundComponent } from './components/diagram-round/diagram-round.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PhonePickerComponent } from './components/phone-picker/phone-picker.component';
import { BeaconZoneComponent } from './components/beacon-zone/beacon-zone.component';
import { SpecialFormComponent } from './components/special-form/special-form.component';
import { NgxMaskModule } from 'ngx-mask';
import { TextMaskModule } from 'angular2-text-mask';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormModalComponent } from './components/form-modal/form-modal.component';
import { FormQuestionnaireComponent } from './components/form-questionnaire/form-questionnaire.component';
import { CalendarHoursComponent } from './components/calendar-hours/calendar-hours.component';
import { DraggableDirective } from './directives/draggable.directive';


import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EbsAlertComponent } from './components/ebs-alert/ebs-alert.component';
import { ShowEbsalertInfoComponent } from './components/show-ebsalert-info/show-ebsalert-info.component';
import { DownloadFileDocumentComponent } from './components/download-file-document/download-file-document.component';
import { UploadFileDocumentComponent } from './components/upload-file-document/upload-file-document.component';
import { SidenavComponent } from './layout/sidenav.component';
import { PopUpHtmlComponent } from './components/pop-up-html/pop-up-html.component';
import { NewHeaderComponent } from './layout/new-header/new-header.component';
import { ValidateErrorsDynamicListComponent } from './components/validate-errors-dynamic-list/validate-errors-dynamic-list.component';
import { StarsComponent } from './components/stars/stars.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { DatePickerPlannerComponent } from './components/date-picker-planner/date-picker-planner.component';
import { LeftPanelComponent } from './components/left-panel/left-panel.component';
import { RightPanelComponent } from './components/right-panel/right-panel.component';
import {CalendarModule} from 'primeng/calendar';
import {RightEmergencyPanelComponent} from './components/right-emergency-panel/right-emergency-panel.component';
import {AlarmPhonePanelComponent} from './components/alarm-phone-panel/alarm-phone-panel.component';
import {PopUpRegisterComponent} from './components/pop-up-register/pop-up-register.component';
import {RightProjectPanelComponent} from './components/right-project-panel/right-project-panel.component';
import {ToastOptionMiddleComponent} from './components/toast-option-middle/toast-option-middle.component';
import { AnnouncementBannerComponent } from './components/announcement-banner/announcement-banner.component';
import { ChatDockComponent } from './components/chat-dock/chat-dock.component';
import { ToastComponent } from './components/toast/toast.component';
import { ChatPageComponent } from './components/chat-page/chat-page.component';
import {CheckStatusUserComponent} from './components/check-status-user/check-status-user.component';
import {NoThousandsSeparatorPipe} from './pipes/no-thousands-separator.pipe';
import {MiddleEllipsisPipe} from './pipes/middle-ellipsis.pipe';
import {AddressTextComponent} from './components/address-text/address-text.component';
import {RightTempPanelComponent} from './components/right-temp-panel/right-temp-panel.component';
import {RightEbsPanelComponent} from './components/right-ebs-panel/right-ebs-panel.component';
import {RightObsPanelComponent} from './components/right-obs-panel/right-obs-panel.component';
import {RightContactPanelComponent} from './components/right-contact-panel/right-contact-panel.component';
import {ShowAvatarBandComponent} from './components/show-avatar-band/show-avatar-band.component';
import {BatteryLevelComponent} from './components/battery-level/battery-level.component';
import {PopUpReportsComponent} from './components/pop-up-reports/pop-up-reports.component';
import {DashboardHeaderComponent} from './layout/dashboard-header/dashboard-header.component';
import {ChartsModule} from 'ng2-charts';
import {PopUpHoursComponent} from './components/pop-up-hours/pop-up-hours.component';
import {PopUpChangeImeiComponent} from './components/pop-up-change-imei/pop-up-change-imei.component';
import {PopUpAssignUsersComponent} from './components/pop-up-assign-users/pop-up-assign-users.component';
import {ValidateService} from './services';
import {PopUpReportsUserComponent} from './components/pop-up-reports-user/pop-up-reports-user.component';
import {PopUpDocumentComponent} from './components/pop-up-document/pop-up-document.component';
import {PopUpAddMedicineComponent} from "./components/pop-up-add-medicine/pop-up-add-medicine.component";
import {PopUpAddMedicineVComponent} from "./components/pop-up-add-medicine-v/pop-up-add-medicine-v.component";
import {PopUpAddNoteComponent} from "./components/pop-up-add-note/pop-up-add-note.component";
import {RightBeaconPanelComponent} from "./components/right-beacon-panel/right-beacon-panel.component";
import {BeaconZonePanelComponent} from "./components/beacon-zone-panel/beacon-zone-panel.component";
import {AlertBoxComponent} from "./components/alert-box/alert-box.component";
import {RedirectMobileComponent} from "./components/redirect-mobile/redirect-mobile.component";
import {AlarmPreviewComponent} from './components/alarm-preview/alarm-preview.component';
import {PatientCallsComponent} from './components/patient-calls/patient-calls.component';
import {DocumentPreviewComponent} from './components/document-preview/document-preview.component';
import {TutorialComponent} from './components/tutorial/tutorial.component';
import {FormDebugDirective} from "./directives/form-debug.directive";
import { ScrollSentinelDirective } from './directives/scroll-sentinel.directive';
import { CountUpDirective } from './directives/count-up.directive';
import { StaggerInDirective } from './directives/stagger-in.directive';
import { SlideUpOnRemoveDirective } from './directives/slide-up-on-remove.directive';
import { ShakeInvalidDirective } from './directives/shake-invalid.directive';
import { ListStateComponent } from './components/list-state/list-state.component';
import {BadgeIconComponent} from './components/badge-icon/badge-icon.component';
import { ScrollFooterComponent } from './components/scroll-footer/scroll-footer.component';
import { ScrollTopComponent } from './components/scroll-top/scroll-top.component';
import {CopyIconComponent} from './components/copy-icon/copy-icon.component';
import {CopyLocationComponent} from './components/copy-location/copy-location.component';
import { CopyButtonComponent } from './components/copy-button/copy-button.component';
import { CopyOnClickDirective } from './directives/copy-on-click.directive';
import { BusyButtonDirective } from './directives/busy-button.directive';
import { TimezoneFieldDirective } from './directives/timezone-field.directive';
import { TimezonePickerComponent } from './components/timezone-picker/timezone-picker.component';
import {ConsentDocumentsComponent} from './components/consent-documents/consent-documents.component';
import {RegisterStepperComponent} from './components/register-stepper/register-stepper.component';
import {ToggleSwitchComponent} from './components/toggle-switch/toggle-switch.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    TranslateModule,
    NgbModule,
    LoadingModule,
    AgmCoreModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatChipsModule,
    MatDatepickerModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCheckboxModule,
    TextMaskModule,
    NgxMaskModule,
    CalendarModule,
    ChartsModule
  ],
  providers: [
    ValidateService,
    GeocodingService
  ],
  declarations: [
    FieldErrorsComponent,
    ShowAuthedDirective,
    PlacesAutocompleteDirective,
    EnableControlDirective,
    FormDebugDirective,
    ScrollSentinelDirective,
    ScrollFooterComponent,
    ScrollTopComponent,
    CountUpDirective,

    StaggerInDirective,
    SlideUpOnRemoveDirective,
    ShakeInvalidDirective,
    ListStateComponent,
    PopUpComponent,
    PopUpRegisterComponent,
    PopUpAddNoteComponent,
    PopUpAddMedicineComponent,
    PopUpAddMedicineVComponent,
    PopUpDocumentComponent,
    PopUpReportsUserComponent,
    PopUpHoursComponent,
    PopUpChangeImeiComponent,
    PopUpAssignUsersComponent,
    PopUpReportsComponent,
    DatePickerComponent,
    DatePickerPlannerComponent,
    DateRangePickerComponent,
    ChangeAvatarComponent,
    NoThousandsSeparatorPipe,
    MiddleEllipsisPipe,
    AddressTextComponent,
    SearchComponent,
    SearchFieldComponent,
    NumberCounterComponent,
    HoursBarComponent,
    SliderComponent,
    AlarmZoneComponent,
    AlertBoxComponent,
    BeaconZoneComponent,
    BeaconZonePanelComponent,
    RouteRefreshComponent,
    CurrentDateComponent,
    SignalStrengthComponent,
    BatteryLevelComponent,
    ValidateErrorsComponent,
    ValidateErrorsDynamicListComponent,
    StarsComponent,
    FilterButtonComponent,
    RangeDatePickerComponent,
    SosAlertComponent,
    NotificationsComponent,
    CheckStatusComponent,
    CheckStatusUserComponent,
    ShowAvatarComponent,
    ShowAvatarBandComponent,
    ShowAlertInfoComponent,
    ShowAlertInfoIntegrateComponent,
    ShowMapInfoComponent,
    DiagramComponent,
    DiagramRoundComponent,
    PaginationComponent,
    PhonePickerComponent,
    LeftPanelComponent,
    RightEmergencyPanelComponent,
    AlarmPhonePanelComponent,
    RightProjectPanelComponent,
    RightBeaconPanelComponent,
    ToastOptionMiddleComponent,
    RightPanelComponent,
    RedirectMobileComponent,
    RightTempPanelComponent,
    RightEbsPanelComponent,
    RightObsPanelComponent,
    RightContactPanelComponent,
    SpecialFormComponent,
    FormModalComponent,
    FormQuestionnaireComponent,
    EbsAlertComponent,
    ShowEbsalertInfoComponent,
    CalendarHoursComponent,
    DownloadFileDocumentComponent,
    UploadFileDocumentComponent,
    SidenavComponent,
    PopUpHtmlComponent,
    NewHeaderComponent,
    DashboardHeaderComponent,
    LeftPanelComponent,
    DraggableDirective,
    AlarmPreviewComponent,
    PatientCallsComponent,
    DocumentPreviewComponent,
    TutorialComponent,
    BadgeIconComponent,
    CopyIconComponent,
    CopyLocationComponent,
    CopyButtonComponent,
    CopyOnClickDirective,
    BusyButtonDirective,
    TimezoneFieldDirective,
    TimezonePickerComponent,
    AnnouncementBannerComponent,
    ChatDockComponent,
    ToastComponent,
    ChatPageComponent,
    ConsentDocumentsComponent,
    RegisterStepperComponent,
    ToggleSwitchComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FieldErrorsComponent,
    RouterModule,
    ShowAuthedDirective,
    PlacesAutocompleteDirective,
    FormDebugDirective,
    EnableControlDirective,
    ScrollSentinelDirective,
    ScrollFooterComponent,
    ScrollTopComponent,
    CountUpDirective,

    StaggerInDirective,
    SlideUpOnRemoveDirective,
    ShakeInvalidDirective,
    ListStateComponent,
    TranslateModule,
    PopUpComponent,
    PopUpRegisterComponent,
    PopUpAddNoteComponent,
    PopUpAddMedicineComponent,
    PopUpAddMedicineVComponent,
    PopUpReportsUserComponent,
    PopUpDocumentComponent,
    PopUpHoursComponent,
    PopUpChangeImeiComponent,
    PopUpAssignUsersComponent,
    PopUpReportsComponent,
    NgbModule,
    DatePickerComponent,
    DatePickerPlannerComponent,
    DateRangePickerComponent,
    ChangeAvatarComponent,
    AnnouncementBannerComponent,
    ChatDockComponent,
    ToastComponent,
    ChatPageComponent,
    SearchComponent,
    SearchFieldComponent,
    NoThousandsSeparatorPipe,
    MiddleEllipsisPipe,
    AddressTextComponent,
    NumberCounterComponent,
    SliderComponent,
    HoursBarComponent,
    AlarmZoneComponent,
    AlertBoxComponent,
    CurrentDateComponent,
    SignalStrengthComponent,
    BatteryLevelComponent,
    ValidateErrorsComponent,
    ValidateErrorsDynamicListComponent,
    StarsComponent,
    FilterButtonComponent,
    RangeDatePickerComponent,
    SosAlertComponent,
    EbsAlertComponent,
    NotificationsComponent,
    CheckStatusComponent,
    CheckStatusUserComponent,
    ShowAvatarComponent,
    ShowAvatarBandComponent,
    ShowAlertInfoComponent,
    ShowAlertInfoIntegrateComponent,
    ShowEbsalertInfoComponent,
    LoadingModule,
    AgmCoreModule,
    DiagramComponent,
    DiagramRoundComponent,
    PaginationComponent,
    PhonePickerComponent,
    BeaconZoneComponent,
    BeaconZonePanelComponent,
    SpecialFormComponent,
    MatInputModule,
    MatIconModule,
    MatExpansionModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    LeftPanelComponent,
    RightEmergencyPanelComponent,
    AlarmPhonePanelComponent,
    RightProjectPanelComponent,
    RightBeaconPanelComponent,
    RightTempPanelComponent,
    RightEbsPanelComponent,
    RightObsPanelComponent,
    RightContactPanelComponent,
    ToastOptionMiddleComponent,
    RightPanelComponent,
    RedirectMobileComponent,
    MatSliderModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatStepperModule,
    NgxMaskModule,
    TextMaskModule,
    FormModalComponent,
    FormQuestionnaireComponent,
    MatProgressSpinnerModule,
    CalendarHoursComponent,
    DownloadFileDocumentComponent,
    UploadFileDocumentComponent,
    SidenavComponent,
    NewHeaderComponent,
    DashboardHeaderComponent,
    DraggableDirective,
    AlarmPreviewComponent,
    PatientCallsComponent,
    DocumentPreviewComponent,
    TutorialComponent,
    BadgeIconComponent,
    CopyIconComponent,
    CopyLocationComponent,
    CopyButtonComponent,
    CopyOnClickDirective,
    BusyButtonDirective,
    TimezonePickerComponent,
    ConsentDocumentsComponent,
    RegisterStepperComponent,
    ToggleSwitchComponent,
  ]
})
export class SharedModule { }
